// extracted by mini-css-extract-plugin
export default {"searchBox":"ProductSearch_searchBox__PWtj2","searchIcon":"ProductSearch_searchIcon__rIvtg","searchInput":"ProductSearch_searchInput__aGu17"};